import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import Watashi from './components/watashi/Watashi'
import reportWebVitals from './reportWebVitals';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import Artwork from './components/artwork/Artwork';
import Projects from './components/projects/Projects';
import Login from './components/login/Login';

const router = createBrowserRouter([
  {path: "/", element: <App />},
  {path: "/login", element: <Login />},
  {path: "/watashi", element: <Watashi />},
  {path: "/artwork", element: <Artwork />},
  {path: "/projects", element: <Projects />}
]);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <RouterProvider router={router} basename={process.env.PUBLIC_URL}/>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
